export default __webpack_public_path__ + "static/media/nft_left_pop.53798279.svg";